import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import YoutubeListLayer from "../components/YoutubeListLayer";

const YoutubeListPage = () => {
    return (
        <MasterLayout>
            <YoutubeListLayer />
        </MasterLayout>
    );
};

export default YoutubeListPage;
